import React from "react";
import { useTranslation } from "react-i18next";

import { NormalButton } from "../NormalButton";
import "./commonTableStyle.scss";
import mobileTickIcon from "../../../assets/svg/mobileTickIcon.svg";
import mobilePlusOrange from "../../../assets/svg/mobilePlusOrange.svg";
import {value} from "lodash/seq";

export const CommonTableMobile = ({ headerData, tableData }) => {
    const { i18n, t } = useTranslation(); 
    const isRTL = i18n.dir() === "rtl";
        let {
        header1Title,
        headerComprehensive,
        header2Title,
        header3Title,
        header4Title,
        bestSeller
    } =headerData;
    return (
        <React.Fragment>
            <div className="common-table-header">
                <div className="table-custom-common">
                    <div className="table-row">
                        <div className="column-table column-first">
                            <h3 className="heading-table">{header1Title}</h3>
                        </div>
                        <div className="column-table column-other bordered-column">
                            <div className="best-seller">
                                {bestSeller}
                            </div>
                            <h4 className="heading-table-2">{header2Title}</h4>
                            <p className="tag-tile">{headerComprehensive}</p>
                        </div>
                        <div className="column-table column-other">
                            <h4 className="heading-table-2">{header3Title}</h4>
                        </div>
                        <div className="column-table column-other">
                            <h4 className="heading-table-2">{header4Title}</h4>
                        </div>
                    </div>
                    {tableData.map((value, index) => {
                        return (
                            <div className={`table-row ${index % 2 == 0 ? 'white-bg' : 'transparent'}`}>
                                <div className="column-table column-first center">
                                    <h3 className="heading-table">{value.title}</h3>
                                </div>
                                <div className={`column-table column-other bordered-column center`}>
                                    <h4 className="heading-table-2">
                                        {value.item1?<img src={value.item1} alt="tableData"/>
                                            :value.text1}
                                    </h4>
                                </div>
                                <div className="column-table column-other center">
                                    <h4 className="heading-table-2">
                                        {value.item2?<img src={value.item2} alt="tableData"/>
                                            :value.text2}
                                    </h4>
                                </div>
                                <div className="column-table column-other center">
                                    <h4 className="heading-table-2">
                                        {value.item3?<img src={value.item3} alt="tableData"/>
                                            :value.text3}
                                        </h4>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </React.Fragment>
    );
};
